export default __webpack_public_path__ + "static/media/clustered-bar-combo-chart.d2db8c00.svg";